export default __webpack_public_path__ + "static/media/circleContact.d18bf11d.svg";